export default __webpack_public_path__ + "static/media/websafe-365-main-app-ui.db28d40b.png";